import * as React from "react";
import { ShieldTask28Regular, ShieldTask28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const TorusApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "Torus" */ "./TorusApp");
    return { default: namedExport.TorusApp };
});

export const Torus: TeamAppConfig = {
    title: "Torus",
    regularIcon: ShieldTask28Regular,
    filledIcon: ShieldTask28Filled,
    description: "The Torus app allows you to interact with Torus services from M365 Pulse.",
    team: "O365ServiceAuth",
    publicId: "EXCHANGE\\ServiceAuth",
    owner: "o365-service-auth-oc@microsoft.com",
    role: "*",
    tags: [],
    app: TorusApp,
    path: "/Torus"
};
